module.exports = __webpack_public_path__ + "static/media/Liberianlogo.14ad8ccd.png";